import React, { useEffect, useState } from "react";
import { getHeroSection } from "../../api/commonApi";
import homeBg from "../../assets/images/landingpage/homebg.webp";
import home from "../../assets/images/landingpage/home.webp";
import qrPlay from "../../assets/images/Avita Play Store.png";
import qrAppStore from "../../assets/images/Avita App Store.png";
import badgePlay from "../../assets/images/landingpage/home3.webp";
import badgeAppStore from "../../assets/images/landingpage/home4.webp";

const BottomCarousel = () => {
  return (
    <div className="w-full -mt-16 md:-mt-20 overflow-hidden">
      <div className="relative">
        <div className="h-8 md:h-10 bg-transparent transform rotate-[-3deg] -mt-1"></div>
        <div className="h-3 md:h-4 bg-[#FBE580] transform rotate-[-3deg]"></div>
        <div className="bg-[#87004C] py-3 overflow-hidden transform rotate-[-3deg]">
          <div className="whitespace-nowrap animate-marquee text-white heading-style">
            {Array(20).fill("Avita Residences • ").join(" ")}
          </div>
        </div>
        <div className="h-8 md:h-10 bg-white transform rotate-[-3deg] -mt-1"></div>
      </div>
    </div>
  );
};

const HomeSection = () => {
  const [heroContent, setHeroContent] = useState({
    heading: "",
    content1: "",
    imageUrl: "",
  });

  useEffect(() => {
    const fetchHeroContent = async () => {
      try {
        const response = await getHeroSection();
        if (response && response.data) {
          setHeroContent({
            heading: response.data.heading,
            content1: response.data.content1,
            content2: response.data.content2,
            imageUrl: response.data.imageUrl,
          });
        }
      } catch (error) {
        console.error("Error loading hero section:", error);
      }
    };

    fetchHeroContent();
  }, []);

  return (
    <>
      <section
        id="home"
        className="relative overflow-hidden min-h-screen"
        style={{
          backgroundImage: `url(${home})`, // yellow gradient bg
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Content container */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 pt-28 md:pt-32 pb-16 grid md:grid-cols-2 gap-10 items-start">
          {/* Left side content */}
          <div>
            <p className="text-md font-Inter text-black mb-2">{heroContent.content2}</p>
            <h1 className="text-4xl font-bold leading-tight text-black">
              {heroContent.heading}
            </h1>
            <p className="heading-style text-[#87004C]">
              {heroContent.content1}
            </p>

            <div className="flex gap-6 mt-6">
              <div>
                <img src={qrPlay} alt="Google Play QR" className="w-28 h-28 rounded-md" />
                <img src={badgePlay} alt="Google Play" className="mt-2 w-28 rounded-md" />
              </div>
              <div>
                <img
                  src={qrAppStore}
                  alt="App Store QR"
                  className="w-28 h-28"
                />
                <img
                  src={badgeAppStore}
                  alt="App Store"
                  className="mt-2 w-28"
                />
              </div>
            </div>
            <p className="flex items-center gap-2 text-md text-black mt-4">
              📍 No 72,Aadhiparasakthi Nagar,Thailavaram,Potheri,Kancheepuram-603203
            </p>
          </div>
        </div>

        {/* Building image for mobile view */}
        <div className="flex justify-center md:hidden pt-8 pb-16">
          <img
            src={heroContent.imageUrl}
            alt="Avita building"
            className="w-full max-w-xs object-contain"
          />
        </div>

        {/* Building image (background style) */}
        <img
          src={heroContent.imageUrl}
          alt="Avita building"
          className="hidden md:block absolute top-28 md:top-32 right-0 bottom-32 md:bottom-40
             w-full max-w-xl lg:max-w-3xl object-contain z-0
             transform scale-95 md:scale-90 origin-top-right pointer-events-none select-none"
        />
      </section>

      <BottomCarousel />
    </>
  );
};

export default HomeSection;
